var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandColorSnapshot = function SvgBrandColorSnapshot(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5595 3.3763L12.8462 10.5769L19.2703 10.7383C19.6965 10.749 19.8816 11.2825 19.5535 11.5549L7.75266 21.3499C7.56122 21.5088 7.28849 21.294 7.39811 21.0706L11.0385 13.6538H4.33982C4.0532 13.6538 3.92227 13.2965 4.14104 13.1113L16.0872 3.00041C16.3443 2.78285 16.7138 3.077 16.5595 3.3763Z",
    fill: "#F8AF36"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandColorSnapshot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/brand-color-snapshot.b6f2052ee0761e7e4d9a5c635456a6d1.svg";